(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("video-bg");
  const placeholder = document.querySelector(".video-placeholder");

  function removePlaceholder() {
    video.style.opacity = "1";
    placeholder.style.opacity = "0";
    setTimeout(() => {
      placeholder.style.display = "none";
    }, 500);
  }

  // If the video is already loaded, remove the placeholder immediately
  if (video.readyState >= 3) {  // 3 = HAVE_FUTURE_DATA (video is loaded)
    removePlaceholder();
  } else {
    // Otherwise, wait for the video to load
    video.addEventListener("loadeddata", removePlaceholder);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const continueBtn = document.querySelector(".continue");
  const targetSection = document.querySelector(".section-target-focus");

  if (continueBtn && targetSection) {
    continueBtn.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent default action if it's a link

      const offset = 100; // Stop 100px before the top
      const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY - offset;
      const startPosition = window.scrollY;
      const distance = targetPosition - startPosition;
      const duration = 800; // Increase duration for slower scroll
      let startTime = null;

      function scrollAnimation(currentTime) {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);

        // Smooth easing function
        window.scrollTo(0, startPosition + distance * easeInOutQuad(progress));

        if (timeElapsed < duration) {
          requestAnimationFrame(scrollAnimation);
        }
      }

      function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      }

      requestAnimationFrame(scrollAnimation);
    });
  }
});




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
  const slicknavBtn = document.querySelector(".slicknav_btn");
  const mobileMenuMain = document.querySelector(".mobile_menu_main");
  
  // Function to update mobile_menu_main height
  function updateMainDropdownHeight() {
      if (mobileMenuMain.style.maxHeight !== "0px") {
          mobileMenuMain.style.maxHeight = mobileMenuMain.scrollHeight + "px";
      }
  }
  
  // Open/Close Main Dropdown
  slicknavBtn.addEventListener("click", function () {
      if (mobileMenuMain.style.maxHeight === "0px" || !mobileMenuMain.style.maxHeight) {
          mobileMenuMain.style.maxHeight = mobileMenuMain.scrollHeight + "px";
      } else {
          mobileMenuMain.style.maxHeight = "0px";
      }
  });
  
  // Toggle Individual FAQs
  const faqTriggers = document.querySelectorAll(".open_trigger_btn");
  
  faqTriggers.forEach(trigger => {
      trigger.addEventListener("click", function (event) {
          event.preventDefault(); // Prevent `<a>` default behavior
  
          const faqContent = this.closest(".mobile_menu_item").querySelector(".mm_content");
  
          if (faqContent.style.height === "0px" || !faqContent.style.height) {
              faqContent.style.height = faqContent.scrollHeight + "px";
              faqContent.classList.add("open");
          } else {
              faqContent.style.height = "0px";
              faqContent.classList.remove("open");
          }
  
          this.classList.toggle("open"); // Rotate icon
  
          // Update the main dropdown height to accommodate FAQ expansion
          setTimeout(updateMainDropdownHeight, 400); // Wait for FAQ animation to finish
      });
  });
  });




  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      // this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
